import React from 'react';
import useStyles from './CustomIncident.styles';
import Conditional from '../../../conditional';
import thumbUp from '../../../../../assets/images/thumb-up.svg';
import thumbDown from '../../../../../assets/images/thumb-down.svg';
import thumbUpGreen from '../../../../../assets/images/thumb-up-green.svg';
import thumbDownRed from '../../../../../assets/images/thumb-down-red.svg';
import { injectIntl } from 'react-intl';

const CustomIncident = ({
  intl: { formatMessage },
  enabled,
  incident,
  onPositive,
  onNegative,
}) => {
  const classes = useStyles();

  const notAvailable = formatMessage({ id: 'orders.historical.nonAvailable' });

  const handlOnPositive = event => {
    event.stopPropagation();
    onPositive();
  };

  const handlOnNegative = event => {
    event.stopPropagation();
    onNegative();
  };

  return (
    <div className={classes.thumbAction}>
      <Conditional if={enabled}>
        <Conditional if={incident === null}>
          <div className={classes.icon} onClick={handlOnPositive}>
            <img src={thumbUp} alt='icon' />
          </div>
          <div className={classes.icon} onClick={handlOnNegative}>
            <img src={thumbDown} alt='icon' />
          </div>
        </Conditional>
        <Conditional if={incident !== null && incident}>
          <div className={classes.icon}>
            <img src={thumbUpGreen} alt='icon' />
          </div>
        </Conditional>
        <Conditional if={incident !== null && !incident}>
          <div className={classes.icon}>
            <img src={thumbDownRed} alt='icon' />
          </div>
        </Conditional>
      </Conditional>
      <Conditional if={!enabled}>
        <div>{notAvailable}</div>
      </Conditional>
    </div>
  );
};

export default injectIntl(CustomIncident);
